import { StyledSection } from './styles';

interface Props {
    children: React.ReactNode;
    fullOnMobile?: boolean;
    paddingBottomNone?: boolean;
    paddingTopNone?: boolean;
    background?: 'green' | 'gray';
    customPadding?: string;
    gap?: string;
}
export const BaseSection = ({
    children,
    fullOnMobile = false,
    paddingBottomNone = false,
    paddingTopNone = false,
    background,
    customPadding,
    gap,
}: Props) => {
    return (
        //TODO  Przepisać na chakra UI
        <StyledSection
            $background={background}
            $fullOnMobile={fullOnMobile}
            $paddingBottomNone={paddingBottomNone}
            $paddingTopNone={paddingTopNone}
            $customPadding={customPadding}
            $gap={gap}
        >
            {children}
        </StyledSection>
    );
};
